export function pluralFilter () {
	return (input, count, suffix) => {
		if (parseInt(count, 10) > 1 || parseInt(count, 10) === 0) {
			return input + (suffix || 's');
		}
		return input;
	};
}
